import script from "./ContentIdentifiers.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentIdentifiers.vue?vue&type=script&lang=ts&setup=true"

import "./ContentIdentifiers.vue?vue&type=style&index=0&id=e598552a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e598552a"]])

export default __exports__